import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {
  private _slbDataPartitionID = '';
  private _consumptionHubInstance = '';

  get clientId(): string {
    return environment.clientId;
  }

  get appKey(): string {
    return environment.appKey;
  }

  get slbDataPartitionID(): string {
    return this._slbDataPartitionID;
  }

  get consumptionHubInstance(): string {
    return this._consumptionHubInstance;
  }

  get consumptionHubPath(): string {
    return environment.consumptionHubPath;
  }

  get dataSource(): string {
    return environment.dataSource;
  }

  get consumptionHubBaseUrl(): string {
    if (!this._consumptionHubInstance) {
      throw new Error('No consumption hub instance configured. Fetch context first.');
    }
    const basePath = this.consumptionHubPath.startsWith('/')
      ? this.consumptionHubPath
      : `/${this.consumptionHubPath}`;
    return `${this._consumptionHubInstance}${basePath}`;
  }

  setDataPartition(partitionId: string): void {
    const normalizedPartitionId = partitionId?.trim().toLowerCase() || '';
    const allowedPartitionIds = environment.allowedSlbPartitionIds.map((id) => id.toLowerCase());
    if (normalizedPartitionId && allowedPartitionIds.length > 0 && !allowedPartitionIds.includes(normalizedPartitionId)) {
      this._slbDataPartitionID = '';
      throw new Error('This environment can only access the adme-int partition. Select adme-int in DELFI and try again.');
    }
    this._slbDataPartitionID = normalizedPartitionId;
  }

  setConsumptionHubInstance(instanceUrl: string): void {
    // If an override is set in the environment, always use that.
    if (environment.apiBaseUrlOverride) {
      this._consumptionHubInstance = environment.apiBaseUrlOverride.trim().replace(/\/+$/, '');
      console.log('[Config] Using apiBaseUrlOverride:', this._consumptionHubInstance);
      return;
    }

    console.log('[Config] Raw instance value from user context:', instanceUrl);

    if (typeof instanceUrl !== 'string' || !instanceUrl.trim()) {
      // Fallback: default to standard production URL
      this._consumptionHubInstance = 'https://api.delfi.slb.com';
      console.warn('[Config] No instance URL in context, falling back to https://api.delfi.slb.com');
      return;
    }

    const trimmed = instanceUrl.trim().replace(/\/+$/, '');

    // Use the instance URL as-is if it looks like a full hostname/URL,
    // otherwise map known shorthand values.
    if (trimmed.startsWith('http')) {
      this._consumptionHubInstance = trimmed;
    } else {
      // CSI sometimes returns just a hostname like 'api.delfi.slb.com'
      this._consumptionHubInstance = `https://${trimmed}`;
    }

    console.log('[Config] Resolved consumptionHubInstance:', this._consumptionHubInstance);
  }
}
